<template>
  <div class="life">
    <Minibar
      :color="getHealthColor()"
      :back="true"
      :val="obj.hp"
      :max="obj.mhp"
      :text="true"
    />

    <Minibar
      :text="true"
      :color="'purple'"
      :val="obj.passive[0].exp"
      :max="obj.passive[0].nexp"
    />
  </div>
</template>

<script>
import Minibar from "./Minibar";

export default {
  props: {
    obj: Object,
  },
  components: { Minibar },

  methods: {
    getHealthColor() {
      let p = (this.obj.hp / this.obj.mhp) * 100;

      if (p >= 80) {
        return "green";
      }
      if (p >= 60) {
        return "lightgreen";
      }
      if (p >= 40) {
        return "yellow";
      }
      if (p >= 20) {
        return "orange";
      }
      return "red";
    },
  },
};
</script>

<style scoped>
.life {
  height: 20px;
  position: relative;
  user-select: none;
  border: 1px solid black;
  padding: 10px;
  margin: 5px;
  background: lightgray;
  width: 180px;
  user-select: none;
}
</style>